export const DUE_TODAY_CONGRATULATIONS_STORAGE_KEY =
  "dueTodayCongratulationsDisabled";

export const isDueTodayCongratulationsDisabled = () =>
  localStorage.getItem(DUE_TODAY_CONGRATULATIONS_STORAGE_KEY) === "true";

export const setDueTodayCongratulationsDisabled = (disabled) =>
  localStorage.setItem(DUE_TODAY_CONGRATULATIONS_STORAGE_KEY, String(disabled));
